<!-- 时间组件 -->
<template>
	<div class="block">
		<el-date-picker
			v-model="times[0]"
			type="date"
			value-format="yyyy-MM-dd"
			:picker-options="beginPickerOptions"
			@change="emit"
			:editable="false"
      :clearable="clearable"
			placeholder="开始时间"
		></el-date-picker>
		<span>&nbsp;-&nbsp;</span>
		<el-date-picker
			v-model="times[1]"
			type="date"
			:picker-options="pickerOptions"
			:editable="false"
      :clearable="clearable"
			value-format="yyyy-MM-dd"
			@change="emit"
			placeholder="结束时间"
		></el-date-picker>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
export default {
	mixins: [minxin],
	props: {
    clearable: {
      typeof: Boolean,
      default: true
    },
    beginTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
  },
	data() {
		return {
			times: [new Date(), new Date()],
			placeholder: ['开始日期', '结束日期'],
		}
	},
	components: {},
	computed: {
		beginPickerOptions() {
			return {
				disabledDate(time) {
					return time.getTime() > Date.now()
				},
			}
		},
		pickerOptions() {
			// pickerOptions
			let _this = this
			return {
				disabledDate(time) {
					return (
						time.getTime() > Date.now()
						// Date.now() < time.getTime() < new Date(_this.times[0]).getTime()
					)
				},
			}
		},
	},
	created() {
    if (this.beginTime) {
			this.times = [this.beginTime, new Date(this.endTime)];
		} else {
      if (this.$route.query.beginTime != undefined) {
        this.times = [
          new Date(this.$route.query.beginTime),
          new Date(this.$route.query.endTime),
        ]
      } else {
        this.times = [new Date(), new Date()]
      }
    }
		

		this.emit()
	},
	// activated(){
	//     this.emit();
	// },
	methods: {
		isEariy() {
			return this.times[0]
		},
		emit() {
			this.pickerOptions
			if (
				new Date(this.times[0]).getTime() >
				new Date(this.times[1]).getTime()
			) {
				this.$message.warning('开始时间不能大于结束时间')
			} else {
				this.$emit('time', this.times)
			}
		},
	},
  watch: {
    beginTime () {
      this.times = [this.beginTime, this.endTime];
    }
  }
}
</script>
<style lang="less" scoped></style>
